export function buildAuthorshipJoins(tableVar: string): string {
  return `.leftJoin(createdByUser, eq(${tableVar}.createdBy, createdByUser.id)).leftJoin(updatedByUser, eq(${tableVar}.updatedBy, updatedByUser.id))`
}
